import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const MsTeamsIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        d="M10.357 6.143H5.786v4.571c0 1.263 1.023 2.286 2.285 2.286h2.286c1.263 0 2.286-1.023 2.286-2.286V8.43a2.286 2.286 0 0 0-2.286-2.286Z"
        fill="currentColor"
      />
      <path
        d="M11.714 5.714a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428Z"
        fill="currentColor"
      />
      <path
        d="M14.286 6.143h-2.572c.5.543.857 1.257.857 2.071v3.072a3.43 3.43 0 0 1-.714 2.114c.214.057.428.1.657.1h.057a2.572 2.572 0 0 0 2.572-2.571V7a.857.857 0 0 0-.857-.857Z"
        fill="currentColor"
      />
      <path
        d="M8.071 5.143a2.071 2.071 0 1 0 0-4.143 2.071 2.071 0 0 0 0 4.143Z"
        fill="currentColor"
      />
      <path
        d="M8.071 6.143H3.786A.786.786 0 0 0 3 6.929v4.785a3.214 3.214 0 1 0 6.429 0V6.929a.786.786 0 0 0-.786-.786h-.572Zm-1 5.714H5.5a.429.429 0 0 1 0-.857h.643V9.429H5.5a.429.429 0 0 1 0-.857h2.857a.429.429 0 0 1 0 .857h-.643V11h.643a.429.429 0 0 1 0 .857h-1.286Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default MsTeamsIcon;
